import { GridSize } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import { ApplicationStepContainer } from '@/components/modules/Application/components/_shared/components/ApplicationStepContainer';
import { ApplicationStepNav } from '@/components/modules/Application/components/_shared/components/ApplicationStepNav';
import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { SectionTitle } from '@/components/modules/Application/components/_shared/components/Section/SectionTitle';
import { ContactInformationFormType } from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';
import { useReferences } from '@/components/modules/Application/components/References/_shared/hooks/useReferences';
import { OrderReferenceForm } from '@/components/modules/Application/components/References/components/OrderReferenceForm';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { usePageContext } from '@/contexts/PageContext/PageContext';

export const ReferencesForms = () => {
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { orderReference1, selectedAgent },
  } = useApplicationContext();
  const {
    state: { showLeftMenu },
  } = usePageContext();
  const { onPrev } = useApplicationNavigation();
  const { handleSubmit } = useFormContext();
  const { submitReferences } = useReferences();

  const isReferenceValid = !!orderReference1;

  const gridFormProps = {
    fieldVariant: FieldVariant.form,
    gridProps: { sm: 6 as GridSize, md: (showLeftMenu ? 6 : 12) as GridSize },
  };

  return (
    <ApplicationStepContainer>
      <Section>
        <SectionTitle
          title={'WELCOME_TO_THE_OFFER_PROCESS'}
          titleDynamicDataTexts={[selectedAgent?.name ?? '']}
          subtitle={'WELCOME_TO_THE_OFFER_PROCESS_SUBTITLE'}
        />
        <CustomPaper fill="paper" style={{ paddingBottom: 40 }}>
          <OrderReferenceForm {...gridFormProps} />
        </CustomPaper>
      </Section>
      <ApplicationStepNav
        onNext={handleSubmit((data) => submitReferences(data as ContactInformationFormType))}
        onPrev={onPrev}
        disableOnNext={!isReferenceValid}
        tooltipOnNextDisabled={!isReferenceValid && getTextIdTranslation('DISABLED_TOOLTIP_REFERENCE_ERROR')}
      />
    </ApplicationStepContainer>
  );
};
